import { compose, withPropsOnChange } from 'core/libs/recompose';

import withCounter from 'core/hocs/withCounter';

export function resolveDomId(props) {
  return {
    domId: props.domId || `block-id-${props.counter.issue()}`,
  };
}

export default compose(
  withCounter,
  withPropsOnChange(['requestId'], resolveDomId),
);
